// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"20":"0e539ab0","41":"6c2cf25a","135":"a598a1c6","378":"e35c323f","564":"3a75d39c","566":"94f83a46","810":"a5ed80d4","837":"1687e8d1","858":"28004a3f"}[chunkId] + ".js";
};